import { useEffect } from 'react';
import { useStores } from '@/contexts/StoreContext';
import { initializeProjects } from '@/utils/projectManager';

/**
 * This hook is responsible for initializing the project from localStorage
 * on application startup.
 */
export const useProjectManager = () => {
  const { projectStore, uiStore } = useStores();

  useEffect(() => {
    const currentProject = initializeProjects();

    if (currentProject) {
      if (currentProject.elements.length > 0) {
        projectStore.loadElements(currentProject.elements);
      }
      if (currentProject.viewport) {
        uiStore.setZoom(currentProject.viewport.zoom);
        uiStore.setOffset({
          x: currentProject.viewport.offsetX,
          y: currentProject.viewport.offsetY,
        });
      }
    }
  }, []); // Only run on mount
};
